/* eslint global-require: "off" */
import { merge } from 'lodash';

import iview from 'iview/dist/locale/fr-FR';
import veeValidate from 'vee-validate/dist/locale/fr';
import momentFr from 'moment/locale/fr-ca';

export default merge(
  {
    layouts: require('./fr/layouts').default,
    pages: require('./fr/pages').default,

    models: require('./fr/models').default,

    components: require('./fr/components').default,
    forms: require('./fr/forms').default,
    modals: require('./fr/modals').default,

    errors: require('./fr/errors').default,
  },
  require('./fr/resources').default,

  require('./fr/date').default,

  {
    moment: momentFr,
    veeValidate: {
      name: veeValidate.name,
      attributes: veeValidate.attributes,
      messages: {
        ...veeValidate.messages,
        taken: (field, [value]) => `Le champ ${field} ’${value}’ n'est pas disponible`,
        empty: field => `Le champ ${field} doit être vide`,
      },
    },
    ...iview,
  },
);
